export const EFinixTransactionType = {
  Order: "order",
  Invoice: "invoice",
} as const;

export type TFinixTransactionType =
  (typeof EFinixTransactionType)[keyof typeof EFinixTransactionType];
